import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, orange } from '../colors';
import { buildPaletteForMode, type PaletteTokenMetadata, type Token } from '../panw-palette/token-metadata';

const warningColorTokens = [
  { propertyPath: 'main', tokenName: '--semantic-data-informative-intermediate' },
  { propertyPath: 'highContrast', tokenName: '--data-informative-intermediate-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--data-informative-intermediate-low-contrast' },
] satisfies Token[];

export const warningColorMetadata: PaletteTokenMetadata = {
  componentName: 'status-warning',
  tokens: warningColorTokens,
};

export const warningColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(warningColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: orange[400],
        highContrast: orange[700],
        lowContrast: orange[100],
      }
    : {
        main: orange[400],
        highContrast: orange[100],
        lowContrast: orange[800],
      };
};
